import { Box, useTheme, alpha } from '@mui/material';

type LinearProgressProps = {
  value: number;
};

export const LinearProgress = ({ value }: LinearProgressProps) => {
  const progress = Math.max(0, Math.min(100, value));
  const theme = useTheme();

  return (
    <Box height={8} borderRadius={2.5} width="100%" overflow="hidden" bgcolor={alpha(theme.palette.primary.main, 0.2)}>
      <Box bgcolor="primary.main" height="100%" borderRadius={2.5} width={`${progress}%`} />
    </Box>
  );
};
